



































import {
  computed, defineComponent, ref, useContext, useFetch, useMeta,
} from '@nuxtjs/composition-api';
import { useCache } from '@vue-storefront/cache';

import CategoryBreadcrumbs from '~/components/Breadcrumbs/CategoryBreadcrumbs.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { CategoryTree } from '~/composables';
import { getCategoryTags } from '~/helpers/cacheHelpers';
import { isPaperPage } from '~/helpers/categoryHelpers';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { RouteData } from '~/middleware/url-resolver';
import Alert from '~/modules/catalog/category/components/views/Alert.vue';
import FourthLevelView from '~/modules/catalog/category/components/views/FourthLevelView.vue';
import NonProductListView from '~/modules/catalog/category/components/views/NonProductListView.vue';
import useCategory from '~/modules/catalog/category/composables/useCategory';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  components: {
    SkeletonLoader,
    Alert,
    FourthLevelView,
    NonProductListView,
    CategoryBreadcrumbs,
  },
  setup() {
    const { routeData, category: categoryFromStore } = usePageStore();
    const { error: nuxtError } = useContext();
    const categoryRef = ref<CategoryTree>(categoryFromStore);
    const { loadCategoryMeta, loading } = useCategory();
    const isActive = computed(() => categoryRef.value?.title);
    const { addTags } = useCache();
    const isPaperPageListing = computed(() => isPaperPage(categoryRef.value) && categoryRef.value?.level === 3);

    useFetch(async () => {
      if (!categoryRef.value) {
        categoryRef.value = await loadCategoryMeta({ category_uid: routeData.uid });

        if (!categoryRef.value) {
          nuxtError({ statusCode: 404 });
        }
      }

      addTags(getCategoryTags(categoryRef.value));
    });

    useMeta({
      bodyAttrs: {
        class: 'overflow-x-visible md_overflow-x-hidden',
      },
    });

    return {
      categoryRef,
      loading,
      isActive,
      isPaperPageListing,
      categoryUid: routeData.uid,
      routeData,
    };
  },
  head() {
    return getMetaInfo(this.categoryRef, false, (this.routeData as RouteData).canonicalUrl, true);
  },
});
